import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 10px;
  align-items: center;
  column-gap: 12px;
  grid-template-columns: 1fr min-content;
  display: grid;
`;

export const Content = styled.ul`
  min-height: 40px;
  align-items: center;
  grid-template-columns: 1fr repeat(5, 80px);
  display: grid;
  
  margin: 0;
  list-style: none;
  padding: 6px 16px;
  border-radius: 6px;
  background-color: ${({theme}) => `
    ${theme.variables.accentBackgroundColor};
  `};
  
  li:not(:first-child) {
    text-align: center;
  }
`;
